import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const CarSpotSubscriptionTerms = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />
            <div className="max-w-4xl mx-auto px-4 py-8 md:py-12 mt-16">
                <div className="bg-white rounded-lg shadow-sm p-8 md:p-12">
                    <header className="mb-8 border-b pb-8">
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                            Subscription Terms for Car Spot
                        </h1>
                    </header>

                    <div className="prose prose-blue max-w-none text-gray-700 space-y-6">

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Free Trial</h2>
                            <p>If offered a free trial, you may cancel at any time through your Apple Account settings. To avoid being charged, you must cancel at least 24 hours before the free trial ends. If not cancelled, the subscription will automatically renew to a paid plan. <em>Please note: Any unused portion of a free trial (if offered) will be forfeited if you purchase a premium subscription during the trial period.</em></p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Subscription & Renewal</h2>
                            <p>Payment will be charged to your Apple Account upon confirmation of purchase. Your subscription automatically renews unless auto-renew is turned off at least 24 hours before the end of the current period. Your account will be charged for renewal within 24 hours prior to the end of the current period. To view your purchase history, please visit <a href="https://support.apple.com/en-us/HT204088" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Apple Support</a>.</p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Cancellation</h2>
                            <p>You can manage or cancel your subscription in your Apple Account settings at any time. <em>Important:</em> Uninstalling the app <strong>does not</strong> cancel your subscription. If you cancel, your subscription will stop at the end of the current billing cycle. You will not receive a refund for the current period but will retain access to premium features until the period expires. For help cancelling, visit <a href="https://support.apple.com/en-us/HT202039" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Apple Support</a>.</p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Refunds</h2>
                            <p>All subscription management and billing are handled directly by Apple. Therefore, we cannot issue refunds directly. Except when required by law, paid subscriptions are non-refundable. If you believe you are eligible for a refund, you must contact Apple directly. Please visit <a href="https://support.apple.com/en-us/HT204084" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Apple Refund Support</a>.</p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Pricing Changes</h2>
                            <p>We reserve the right to modify subscription fees or terms in accordance with applicable laws. We will provide reasonable notice of any price changes via the app or email. If you do not accept the new pricing, you may cancel your subscription before the change takes effect.</p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Contact Us</h2>
                            <p>If you have any questions regarding these subscription terms, please email us at <a href="mailto:carspot@apptek.dev" className="text-blue-600 hover:underline"><strong>carspot@apptek.dev</strong></a>.</p>
                        </section>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default CarSpotSubscriptionTerms;
